import { getUser } from "./apiCall";

export const getUserData = async () => {
    return await getUser();
}
